<template>
    <div class="modal-wrapper" @click="closeModal">
        <div class="modal-container" @click.stop>
            <div class="modal-btn-close" @click="closeModal">
                <!-- close button using material icons -->
                <span class="material-symbols-outlined close-icon em2">cancel</span>
            </div>
            
            <div class="modal-body">
                
                <div>
                    <a :href="(settings.isShabbat ? '#' : dealDetails.DealURL)" target="_blank" class="button-link" id="deal-url" @click="goToDeal()">
                        <img :src="dealDetails.ImgUrl" class="mini-deal-img" />
                    </a>    
                </div>
                
                <div class="mini-deal-body-content-title">
                    {{ dealDetails.Title }}
                </div>
                <div class="mini-deal-prices">
                    <div :style="{'visibility': isDealNegativeOne ? 'hidden' : 'visible'}">
                        <div class="crossed-price"><span v-if='dealDetails.RetailPrice'>{{formatPrice(dealDetails.RetailPrice)}}</span></div>
                        <div class="deal-price-container" >
                            <div class="deal-price">{{formatPrice(dealDetails.DealPrice)}}</div>
                            <div class="deal-discount" v-if="discount">-{{discount.toFixed(0)}}%</div>
                        </div>
                    </div>
                </div>
                <div class="deal-provider">
                    <DealLogoImage :deal="dealDetails" class="logo-img" />
                </div>
                <div class="deal-promo-code" v-if="dealDetails.PromoCode">
                    <div class="deal-promo-code-title">Promo Code</div>
                    <div class="share-link-container">
                        <input id="promoCode" v-model="dealDetails.PromoCode" class="promo-code-input" readonly />
                        <a v-show="!copied" class="promo-copy-code" @click="copyToClipboard">COPY</a>
                        <a v-show="copied" class="promo-copy-code copied">COPIED</a>
                    </div>

                </div>
                
                <div class="mini-deal-buttons">
                    <a :href="(settings.isShabbat ? '#' : dealDetails.DealURL)" target="_blank" class="button-link" id="deal-url" @click="goToDeal()">
                        <button class="primary-button centered">
                            Get Deal
                        </button>
                    </a>
                    <ShareButton :link="dealHelper.getDealLink(dealDetails)" :messageTitle="'Check out this deal!'" :messageText="'Found this amazing deal on MommyDeals – thought you’d like it.'" />
                    <GetDealAlerts />
                </div>
                <div class="mini-deal-disclaimer">
                    Disclaimer: We may receive compensation from brands for some of the deals we feature, including promoted items.
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { DealDetails } from '@/classes/DealDetails'
import { globalStore } from '@/stores/globalStore'
import ga from '@/helpers/ga'
import clicky from '@/helpers/clicky'
import settings from '@/settings'
import util from '@/helpers/util'
import dealHelper from '@/helpers/deal-helper'
import ModalDealAlerts from '@/modals/ModalDealAlerts.vue'
import DealLogoImage from './DealLogoImage.vue'
import ShareButton from './ShareButton.vue'
import GetDealAlerts from './GetDealAlerts.vue'

const $globalStore = globalStore()

const props = defineProps<{
    dealDetails: DealDetails
    showDealPrice: boolean
}>()

const showModalDealAlerts = ref(false)


const isDealNegativeOne = computed(() => {
    return props.dealDetails.DealPrice < 0 || !props.showDealPrice
})

const discount = computed(() => {
    return util.getDiscountPercentage(props.dealDetails.DealPrice, props.dealDetails.RetailPrice)
})

const closeModal = () => {
    $globalStore.setSelectedDeal(null)
}

const formatPrice = (price: number) => {
    return price.toFixed(2)
}

const copied = ref(false)

const copyToClipboard = () => {
    navigator.clipboard.writeText(props.dealDetails.PromoCode)
    copied.value = true
    setTimeout(() => {
        copied.value = false
    }, 2000)
}

const trackOutboundLink = (url: string) => {
            ga.event('click', { 'event_category': 'outbound', 'event_label': url, 'transport_type': 'beacon' })
            clicky.goal('DealClick2')
        }

const goToDeal = () => {
            if (settings.isShabbat) {
                alert(`Thank you for your patience while ${settings.siteNameCaps} breaks for the Shabbos holiday.

Deal links will resume to work on ${settings.shabbatEnds}.`)
                event.preventDefault()
            }
            else {
                trackOutboundLink(props.dealDetails.DealURL)
            }
}

</script>

<style scoped>



.mini-deal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.mini-deal-header-title {
    font-size: 1em;
}

    img.mini-deal-img {
        max-height: 10em;
    }

.deal-price{
    font-size: 1.5em;
}

.mini-deal-prices{
    margin-top: 10px;
    margin-bottom: 1em;
}

.mini-deal-split {
    display: grid;
    grid-template-columns: 25% 1fr;
    align-items: center;
}



.mini-deal-disclaimer {
    font-size: 0.8em;
    color: #666;
    text-align: center;
    margin-top: 10px;
}


.deal-provider {
    margin-top: 10px;
    margin-bottom: 10px;
}


</style>
